import { apiClient } from '@indipia/shared';

export interface ReferralCodeValidateResult {
  valid:            boolean;
  referrerName:     string | null;
  /** 리퍼럴 코드/관계 소유권이 sv-member로 이관되며 신설(2026-09-23) — 로그인 상태에서 `?ref=`로
   *  들어온 방문자가 이 값을 그대로 startTrial에 실어보내는 데 쓰인다(billing 에이전트
   *  CheckoutPage 참고). 회원가입 화면은 이 값을 직접 쓰지 않고 referrerName만 보여준다. */
  referrerMemberId: number | null;
}

/** 추천 코드 존재 확인(공개, 회원가입 화면 전용) — GET /member/referrals/validate?code=
 *  비로그인 허용. 자기추천·중복가입 판정은 하지 않는다(가입 완료 시점에 서버가 최종 판정).
 *  2026-09-23부로 sv-billing이 아니라 sv-member 소유(코드 자체가 TU_MEMBER로 이관됨) —
 *  member-join.ts와 동일하게 API_PRX.MEMBER 경로를 쓴다. */
export async function validateReferralCode(code: string): Promise<ReferralCodeValidateResult> {
  const res = await apiClient.get('/member/referrals/validate', { params: { code } });
  return res.data.data as ReferralCodeValidateResult;
}
